import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme } from '../../contexts/ThemeContext'

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()

  // Cycle through themes: light -> dark -> system -> light...
  const cycleTheme = () => {
    const themeOrder = ['light', 'dark', 'system'] as const
    const currentIndex = themeOrder.indexOf(theme)
    const nextIndex = (currentIndex + 1) % themeOrder.length
    setTheme(themeOrder[nextIndex])
  }

  // Get icon based on current theme and resolved theme
  const getIcon = () => {
    if (theme === 'system') {
      return Monitor
    }
    return resolvedTheme === 'dark' ? Moon : Sun
  }

  const Icon = getIcon()

  return (
    <button
      onClick={cycleTheme}
      className="p-2 rounded-md bg-gray-100 hover:bg-gray-200 dark:bg-night-850 dark:hover:bg-night-800 text-gray-700 dark:text-slate-200 transition-all duration-200"
      title={theme === 'system' ? 'System theme' : `${theme} theme`}
    >
      <Icon className="w-4 h-4" />
    </button>
  )
}
